import { Box, alpha, buttonClasses, useTheme } from '@mui/material';
import React, { FC, useCallback, useMemo, useState } from 'react';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import InteractiveTooltip from '../InteractiveTooltip';
import { ShortcutItem } from '../Shortcuts/types';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChecklistRtlOutlinedIcon from '@mui/icons-material/ChecklistRtlOutlined';
import List from '../Shortcuts/List';
import { transition } from 'src/theme';
import { TooltipComponentsSx } from '../InteractiveTooltip/domain';
import ChipButton from '../ChipButton';

type ActionsButtonProps = { label: string };
const ActionsButton: FC<ActionsButtonProps> = ({ label }) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const shortcuts: ShortcutItem[] = useMemo(
    () => [
      {
        title: 'צפה בחשבוניות של החודש הקודם',
        Icon: <ChecklistRtlOutlinedIcon fontSize="small" />,
        onClick: () => {
          // setIsOpen(false);
        },
      },
      {
        title: 'הוסף תיבת דואר חדשה',
        Icon: <ForwardToInboxOutlinedIcon fontSize="small" />,
        onClick: () => {
          // setIsOpen(false);
        },
      },
      {
        title: 'שאלות נפוצות',
        Icon: <HelpOutlineOutlinedIcon fontSize="small" />,
        onClick: () => {
          // setIsOpen(false);
        },
      },
    ],
    [],
  );

  const onButtonClick = useCallback(() => {
    setIsOpen((prevState) => !prevState);
  }, []);

  const componentsSx: TooltipComponentsSx = useMemo(() => {
    return {
      tooltip: {
        padding: 0,
        opacity: 0,
        boxShadow: theme.shadows[3],
      },
    };
  }, []);

  return (
    <InteractiveTooltip
      componentsSx={componentsSx}
      targetPlacement="bottom-end"
      overrideIsOpen={isOpen}
      setOverrideIsOpen={setIsOpen}
      Trigger={
        <ChipButton
          variant="text"
          disableElevation
          onClick={onButtonClick}
          sx={{
            border: ({ palette }) => `1px solid ${palette.divider}`,
          }}
          endIcon={
            <ArrowDropDownOutlinedIcon
              sx={{
                fontSize: 18,
                transition: transition({ duration: 0.4 }),
                transform: `rotateZ(${isOpen ? 180 : 0}deg)`,
              }}
            />
          }
        >
          {label}
        </ChipButton>
      }
      Contents={
        <Box
          component="span"
          display="flex"
          sx={{
            background: ({ palette }) => palette.background.paper,
            color: 'text.primary',
            width: 300,
          }}
        >
          <List shortcuts={shortcuts} />
        </Box>
      }
    />
  );
};

export default ActionsButton;
